import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { LazyMotion, MotionConfig, domAnimation } from "motion/react";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { installErrorReporting } from "./lib/errors";
import { SessionProvider } from "./lib/session";
import { applyTheme, localTheme } from "./lib/theme";
import "@fontsource-variable/bricolage-grotesque/opsz.css";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./styles.css";

registerSW({ immediate: true });
installErrorReporting();
applyTheme(localTheme()); // paint the right theme before the account profile arrives

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/+$/, "")}>
      <ErrorBoundary>
        <SessionProvider>
          {/* LazyMotion + m.* components: animation features load on demand (~5kb initial). */}
          <LazyMotion features={domAnimation} strict>
            <MotionConfig reducedMotion="user">
              <App />
            </MotionConfig>
          </LazyMotion>
        </SessionProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
